import React, {useMemo} from 'react';
import {InputNumber, Select} from 'antd';

/**
 * 아이템 보상 슬롯 컴포넌트
 * slot: { id, type, value }
 * onChange: (newSlot) => void
 * itemData: [{ key, index, itemType, name }]
 */
const ItemRewardSlot = ({slot, onChange, itemData, size = 'small', style}) => {
    const selected = itemData?.find(d => d.index === slot.id && d.itemType === slot.type);

    const options = useMemo(() =>
        (itemData || []).map(item => ({
            value: item.key,
            label: `${item.name} (ID:${item.index})`,
            name: item.name,
            index: item.index,
        })),
        [itemData]
    );

    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: 2, minWidth: 120, ...style}}>
            <Select
                showSearch
                size={size}
                style={{width: '100%'}}
                options={options}
                value={selected?.key}
                placeholder="아이템"
                filterOption={(input, opt) =>
                    opt?.name?.toLowerCase().includes(input.toLowerCase()) ||
                    String(opt?.index).includes(input)
                }
                onChange={val => {
                    const item = itemData?.find(d => d.key === val);
                    if (!item) return;
                    onChange({...slot, id: item.index, type: item.itemType});
                }}
            />
            <InputNumber
                min={0}
                size={size}
                style={{width: '100%'}}
                value={slot.quantity}
                placeholder="수량"
                onChange={val => onChange({...slot, quantity: val || 0})}
            />
        </div>
    );
};

export default ItemRewardSlot;
